import { RouteRecordRaw } from 'vue-router';

export const fmeaRouteConfig: RouteRecordRaw = {
  name: 'fmea',
  path: '/fmea',
  component: () => import('@/components/fmea/layouts/main.vue'),
  redirect: { name: 'fmeaProjects' },
  meta: { accessScope: 'fmea' },
  children: [
    {
      path: '/fmea/projects/:projectId',
      components: {
        default: () => import('@/components/fmea/fmea-project-detail.vue'),
        sidebar: () =>
          import('@/components/fmea/layouts/project-detail-menu.vue'),
      },
      name: 'fmeaProjectDetail',
      meta: { title: 'FMEAプロジェクト詳細' },
    },
    {
      path: '/fmea/projects/:projectId/risk-criteria',
      components: {
        default: () => import('@/components/fmea/fmea-project-detail.vue'),
        sidebar: () =>
          import('@/components/fmea/layouts/project-detail-menu.vue'),
      },
      name: 'fmeaProjectRiskCriteria',
      meta: { title: 'リスク評価基準' },
    },
    {
      path: '/fmea/projects',
      components: {
        default: () => import('@/components/fmea/fmea-projects.vue'),
        sidebar: () => import('@/components/fmea/layouts/home-menu.vue'),
      },
      name: 'fmeaProjects',
      meta: { title: 'FMEAプロジェクト' },
    },
    {
      path: '/fmea/systems/:system_id',
      components: {
        default: () => import('@/components/fmea/fmea-system/fmea-system.vue'),
        sidebar: () => import('@/components/fmea/layouts/system-menu.vue'),
      },
      props: {
        default: route => ({ systemId: String(route.params.system_id) }),
      },
      redirect: { name: 'fmeaWorksheet' },
      children: [
        {
          path: 'resources',
          component: () =>
            import('@/components/fmea/fmea-system/fmea-system-resources.vue'),
          name: 'fmeaSystemResources',
          meta: { title: 'システム情報' },
        },
        {
          path: 'elements',
          component: () =>
            import('@/components/fmea/fmea-system/fmea-system-elements.vue'),
          name: 'fmeaSystemElements',
          meta: { title: 'システムの構成要素' },
        },
        {
          path: 'sheet',
          component: () =>
            import('@/components/fmea/fmea-system/fmea-sheet-layout.vue'),
          name: 'fmeaSheet',
          meta: { title: 'FMEAシート' },
          redirect: { name: 'fmeaWorksheet' },
          children: [
            {
              path: 'worksheet',
              component: () =>
                import('@/components/fmea/fmea-system/fmea-worksheet.vue'),
              name: 'fmeaWorksheet',
              meta: { title: 'FMEAワークシート' },
            },
          ],
        },
      ],
    },
  ],
};
